import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import { ToastContainer } from "react-toastify";
import LandingpagePage from "./pages/Landingpage";
import CategorypagePage from "./pages/Categorypage";
import ProductsPagePage from "./pages/ProductsPage";
import ProductDetailPagePage from "./pages/ProductDetailPage";
import CartReviewPagePage from "./pages/CartReviewPage";
import CartCheckoutAdressPagePage from "./pages/CartCheckoutAdressPage";
import CartCheckoutPaymentPagePage from "./pages/CartCheckoutPaymentPage";
import OrdersPage from "./pages/OrdersPage";
import OrderViewPage from "./pages/OrderViewPage";

// const Quicklookdialog = React.lazy(() => import("components/Quicklookdialog"));
// const Largeimageviewdialog = React.lazy(() =>
//   import("pages/Largeimageviewdialog")
// );
// const CartCheckoutPaymentPage = React.lazy(() =>
//   import("pages/CartCheckoutPaymentPage")
// );
// const CartCheckoutAdressPage = React.lazy(() =>
//   import("pages/CartCheckoutAdressPage")
// );
// const CartReviewPage = import("pages/CartReviewPage");
// const ProductDetailPage = import("pages/ProductDetailPage");
// const ProductsPage = import("pages/ProductsPage");
// const Categorypage = import("pages/Categorypage");
// const Landingpage = import("pages/Landingpage");
const ProjectRoutes = () => {
  return (
    <>
      <React.Suspense fallback={<>Loading...</>}>
        <Router>
          <Routes>
            <Route path="/" element={<LandingpagePage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/home" element={<LandingpagePage />} />
            <Route path="/categorypage" element={<CategorypagePage />} />
            <Route path="/productspage" element={<ProductsPagePage />} />
            <Route path="/productdetailpage" element={<ProductDetailPagePage />} />
            <Route path="/cartreviewpage" element={<CartReviewPagePage />} />
            <Route path="/ordersviewpage" element={<OrdersPage />} />
            <Route path="/orderviewpage" element={<OrderViewPage />} />
            <Route
              path="/cartcheckoutadresspage"
              element={<CartCheckoutAdressPagePage />}
            />
            <Route
              path="/cartcheckoutpaymentpage"
              element={<CartCheckoutPaymentPagePage />}
            />
            {/*<Route*/}
            {/*  path="/largeimageviewdialog"*/}
            {/*  element={<Largeimageviewdialog />}*/}
            {/*/>*/}
            {/*<Route path="/quicklookdialog" element={<Quicklookdialog />} />*/}
            {/*<Route path="/dhiwise-dashboard" element={<Home />} />*/}
          </Routes>
        </Router>
      </React.Suspense>
      <ToastContainer />
    </>
  );
};
export default ProjectRoutes;
